import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SanitizedLineItem } from '../../../../../types/order/Order';

interface SiblingLineItemsDescriptionProps {
  reviewGroupSiblings: SanitizedLineItem[];
}

const SiblingLineItemsDescription = ({ reviewGroupSiblings }: SiblingLineItemsDescriptionProps) => {
  const intl = useIntl();
  const intlAbbreviation = intl.locale.slice(0, 2);

  return (
    <ul className="pd-mt-3">
      {reviewGroupSiblings.map((lineItem) => {
        const { quantity, custom: { fields: { lineItemNumber, childProductDescription } } } = lineItem;

        return (
          <li key={lineItemNumber}>
            {lineItemNumber
              && (
                <span className="pd-font-bold">
                  {`${lineItemNumber}: `}
                </span>
              )}
            <span>
              {`${childProductDescription[intlAbbreviation]}, `}
            </span>
            <FormattedMessage
              id="account.order.orderline.quantity"
              defaultMessage="{quantity} {quantity, plural, one {piece} other {pieces}}"
              values={{ quantity }}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default SiblingLineItemsDescription;
